export const TYPE_BATCH_MULTIPLE = 'multiple'
export const TYPE_BATCH_EZ_SHEET = 'ez_sheet'

export const TYPE_HEADER_NAME = 'name'
export const TYPE_HEADER_DESCRIPTION = 'desc'
